import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { PictureComponent } from "../../../modules/shared/picture/picture.component";

@Component({
    selector: "ls-special-menu-item",
    imports: [
        TranslateModule,
        PictureComponent,
    ],
    templateUrl: "./special-menu-item.component.html",
    styleUrl: "./special-menu-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialMenuItemComponent {
    public lsOnClick = output<void>();

    public name = input<string>("");
    public bgUrl = input<string>("");
    public iconUrl = input<string>("");
    public filterColor = input<string>("");
    public linearGradient = input<string>("");
    public amount = input<number | null>(null);

    public minioUrl: string = environment.minioUrl;

    public click(): void {
        this.lsOnClick.emit();
    }
}
